export default "__VITE_ASSET__BGbZuSNe__"